import React, { useEffect, useMemo } from 'react';
import { useOrchestratorNavigation } from '@wix/gg-components/orchestrator';
import { useLaunchStore } from '../../api';
import { usePaymentsEnabled } from '../../stores/appStore';
import { useStepAnimation } from '../../hooks';
import { LaunchStepsList } from './components/LaunchStepsList';
import { LAUNCH_STEPS, LaunchStepContext } from '../../config/launchSteps';
import { StepLayout } from 'components/StepLayout/StepLayout';
import { useTranslation } from '@wix/wix-i18n-config';

export function LaunchStoreContent() {
  const { t } = useTranslation();
  const { next } = useOrchestratorNavigation();
  const { mutate: launchStore, isPending, isSuccess } = useLaunchStore();
  const paymentsEnabled = usePaymentsEnabled();

  const filteredSteps = useMemo(() => {
    const context: LaunchStepContext = {
      paymentsEnabled,
    };

    return LAUNCH_STEPS.filter((step) => !step.condition || step.condition(context));
  }, [paymentsEnabled]);

  const { currentStep, isComplete: isAnimationComplete } = useStepAnimation({
    totalSteps: filteredSteps.length,
    stepDelay: 2000,
  });

  useEffect(() => {
    launchStore();
  }, [launchStore]);

  useEffect(() => {
    if (!isPending && isAnimationComplete && isSuccess) {
      next();
    }
  }, [isPending, isAnimationComplete, isSuccess, next]);

  return (
    <StepLayout hideHeader hideActions title={t('launch_loader.title')} description={t('launch_loader.subtitle')}>
      <LaunchStepsList steps={filteredSteps} currentStep={currentStep} />
    </StepLayout>
  );
}
